import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeRight16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconEdgeRight16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11 3.5A.75.75 0 1 0 11 2a.75.75 0 0 0 0 1.5M14.113 5a.5.5 0 1 0-1 0v6a.5.5 0 0 0 1 0zM2.75 8.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75-3.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m8.25 8.002a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M8 3.5A.75.75 0 1 0 8 2a.75.75 0 0 0 0 1.5m.75 9.752a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M5 3.5A.75.75 0 1 0 5 2a.75.75 0 0 0 0 1.5m.75 9.752a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-3-1.752a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEdgeRight16);
